import React, { Component } from 'react';
import { UncontrolledButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import cx from 'classnames';

import styles from './decorators.module.scss';

class ButtonDropdownDecorator extends Component {
  render() {
    var { children, className, label, size } = this.props;
    return (
      <UncontrolledButtonDropdown
        className={cx(this.props.groupClassName, styles.dropdownButton)}
      >
        <DropdownToggle color="white" caret>
          {label}
        </DropdownToggle>
        <DropdownMenu
          className={cx(styles.dropdown, className, {
            [styles.dropdownLg]: size === 'lg'
          })}
        >
          {typeof children === 'function' ? children(this.state) : children}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }
}

export default ButtonDropdownDecorator;



// WEBPACK FOOTER //
// ./src/decorators/button-dropdown.js